export enum AnalyticsEvents {
  PageView = "Viewed Page",
  SessionLength = "Session Length",
  ExpandAccordion = "Expand Accordion",
  SwappedCompetitor = "Swapped Competitor",
  ChangeDataType = "Change Data Type",
  FilterDate = "Filter Dates",
  FilterBrand = "Filter Brand",
  FilterDemographics = "Filter Demographics",
  ChangeMetric = "Change Metric",
  Download = "Download",
  Comparison = "Compare Date Ranges",
  FilterUniqueWords = "Filter Unique Words",
  SummaryOpened = "Summary Opened",
  SummaryGenerated = "Summary Generated",
  SummaryError = "Summary Errored",
  SummaryCancelled = "Summary Cancelled",
  Copy = "Copy",
  CopyLink = "Copy Link",
  SelectBrand = "Selected Active Brand",
  SelectMetric = "Selected Active Metric",
  CopyImage = "Copy Image",
  Verbatim = "Viewed Verbatim",
  OpenStatement = "Opened Statement",
  OpenSettings = "Opened Settings Menu",
  ChangeAccount = "Changed Account",
  OpenLink = "Opened Link",
  OpenProfile = "Opened Profile",
  AddMilestone = "Added Milestone",
  EditMilestone = "Edited Milestone",
  DeleteMilestone = "Deleted Milestone",
  ChangeMilestoneVisibility = "Changed Milestone Visibility",
  EasterEgg = "Easter Egg Triggered",
  ChangedConversionOptions = "Changed Conversion Options",
  ChangedConversionMetrics = "Changed Conversion Metrics",
  ChangedTimelineOptions = "Changed Timeline Options",
  SelectedTimelineLine = "Selected Timeline Line",
  HideItem = "Hide Item",
  ShowItem = "Show Item",
  OpenInsightOverview = "Opened Insight Overview",
  OpenDemographicDriver = "Opened Demographic Driver",
  ExpandedEllipsis = "Expanded Ellipsis",
  EducationOpened = "Education Opened",
  OnboardingStepComplete = "Onboarding Step Completed",
  OnboardingSubmitted = "Onboarding Submitted",
  SignUpOpened = "Sign-up Opened",
  SignUpSuccess = "Sign-up Success",
  SignInOpened = "Sign-in Opened",
  SignInSuccess = "Sign-in Success",
  SignInMFAChallengeOpened = "Sign-in MFA Challenge Opened",
  AreaChart = "Area chart legend click",
  ConversionDriver = "Conversion Driver clicked",
  PasswordResetOpened = "Password-reset Opened",
  PasswordResetSuccess = "Password-reset Success",
  PasswordResetCodeSent = "Password-reset Code Sent",
  TooltipActivated = "Tooltip Activated",
  OpenCoachsTips = "Open Coach's Tips",
  OpenCollapsible = "Open Collapsible",
  Hover = "Hovered over",
  LockedPageView = "Viewed Locked Page",
  ClickedFeatureFeedback = "Clicked Feature Feedback",
  OpenedCustomFilter = "Opened Custom Filter",
  SavedCustomFilter = "Saved Custom Filter",
  CancelledCustomFilter = "Cancelled Custom Filter",
  SetDefaultFilter = "Set Default Filter",
  RemovedDefaultFilter = "Removed Default Filter",
  DeletedCustomFilter = "Deleted Custom Filter",
  ClickedFilterBadge = "Clicked Filter Badge",
  InlineNotificationDismissed = "Inline Notification Dismissed",
  EstimatedReachToggle = "Estimated Reach Toggle",
  ToggledEstimatedPopulation = "Toggled Estimated Population",
  ClickedButton = "Clicked Button",
  DisplayMenuOpened = "Display Menu Opened",
  ShareMenuOpened = "Share Menu Opened",
}

const consoleAnalytics = {
  identify: (userId: any, properties: any) => {
    console.log("analytics:identify", { userId, properties });
  },
  track: (eventName: any, properties: any) => {
    console.log("analytics:track", eventName, properties);
  },
  page: (category: any, name: any, properties: any) => {
    console.log("analytics:page", { category, name, properties });
  },
};

export const getAnalytics = (account?: any) => {
  return consoleAnalytics;
};

export const useAnalytics = <T extends Record<string, any>>() => {
  return consoleAnalytics;
};
